export const RECENT_MESSAGE_HOURS = 16;
